import { lazy } from "react";

const routes = [
  {
    path: "/legalentity",
    element: lazy(() => import("../pages/LegalEntity")),
  },
  {
    path: "/legalentity/add",
    element: lazy(() => import("../pages/LegalEntity/create")),
  },
  {
    path: "/legalentity/edit/:id",
    element: lazy(() => import("../pages/LegalEntity/edit")),
  },
];

export default routes;
